module.exports = __webpack_public_path__ + "static/Sonyax54-6517ce2c0aa2774476d4c21ecf671c39.png";